import { http } from "./http";

export const eventsApi = {
  list(params) {
    return http.get("/api/admin/events", { params }).then((r) => r.data);
  },
  stats(params) {
    return http.get("/api/admin/events/stats", { params }).then((r) => r.data);
  },
  keyEvents(key, params) {
    return http
      .get(`/api/admin/keys/${encodeURIComponent(key)}/events`, { params })
      .then((r) => r.data);
  },
  keyDevices(key) {
    return http
      .get(`/api/admin/keys/${encodeURIComponent(key)}/devices`)
      .then((r) => r.data);
  },
  blacklistAdd(body) {
    return http.post("/api/admin/blacklist/add", body).then((r) => r.data);
  },
  blacklistRemove(body) {
    return http.post("/api/admin/blacklist/remove", body).then((r) => r.data);
  },
};
